// extracted by mini-css-extract-plugin
module.exports = {"contactBackSuccessIcon":"contact-back-success_contactBackSuccessIcon__1z3fv","img":"contact-back-success_img__14A5K"};